<div class="transparencia-container">
    <!-- HEADER SECTION -->
    <div class="transparencia-header">
        <div class="container">
            <h1 class="page-title">Transparencia</h1>
            <p class="page-subtitle">Información pública y rendición de cuentas del Gobierno Municipal</p>
        </div>
    </div>

    <div class="container my-5">

        <!-- SECCIÓN 1: ENLACES PRINCIPALES -->
        <div class="card-section">
            <div class="row g-4">

                <!-- Columna Izquierda: Información General -->
                <div class="col-md-6">
                    <div class="info-card">
                        <h3 class="card-title">Información General</h3>
                        <ul class="link-list">
                            <li>
                                <a href="https://nld.gob.mx/assets/pdfs/avisoprivacidad.pdf" target="_blank">
                                    <i class="bi bi-file-earmark-text"></i>
                                    <span>Aviso de Privacidad Integral del Gobierno de Nuevo Laredo</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://obraspublicas.nld.gob.mx" target="_blank">
                                    <i class="bi bi-bar-chart"></i>
                                    <span>Avances de Obras Públicas</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://nld.gob.mx/assets/pdfs/etica.pdf" target="_blank">
                                    <i class="bi bi-shield-check"></i>
                                    <span>Código de Ética y Conducta</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://nld.gob.mx/assets/documentos/manualGestionAmbiental.pdf"
                                    target="_blank">
                                    <i class="bi bi-tree"></i>
                                    <span>Manual del Sistema de Gestión Ambiental</span>
                                </a>
                            </li>
                        </ul>

                        <!-- Normatividad Acordeón -->
                        <div class="accordion-item-custom">
                            <button class="accordion-btn" (click)="toggleNormatividad()">
                                <i class="bi bi-book"></i>
                                <span>Normatividad</span>
                                <i class="bi" [ngClass]="normatividad2024 ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                            </button>
                            <div class="accordion-content" *ngIf="normatividad2024">
                                <div class="sub-links">
                                    <a href="https://nld.gob.mx/assets/normatividad/normatividad1.pdf" target="_blank">
                                        Reglas de Operación del Programa Becas Deportivas UNE
                                    </a>
                                    <a href="https://nld.gob.mx/assets/normatividad/normatividad2.pdf" target="_blank">
                                        Reglas de Operación del Programa Dispensarios Clínicas UNE
                                    </a>
                                    <a href="https://nld.gob.mx/assets/normatividad/normatividad3.pdf" target="_blank">
                                        Reglas de Operación del Programa de Comités Vecinales
                                    </a>
                                    <a href="https://nld.gob.mx/assets/normatividad/normatividad4.pdf" target="_blank">
                                        Reglas de Operación del Programa Becas Escolares UNE
                                    </a>
                                    <a href="https://nld.gob.mx/assets/normatividad/normatividad5.pdf" target="_blank">
                                        Reglas de Operación del Programa Apoyo Útiles para Estudiantes
                                    </a>
                                    <a href="https://nld.gob.mx/assets/normatividad/normatividad6.pdf" target="_blank">
                                        Reglas de Operación del Programa Apoyos para Docentes
                                    </a>
                                    <a href="https://nld.gob.mx/assets/normatividad/normatividad7.pdf" target="_blank">
                                        Reglas de Operación del Programa Becas Culturales UNE
                                    </a>
                                    <a href="https://nld.gob.mx/assets/normatividad/normatividad8.pdf" target="_blank">
                                        Reglas de Operación del Programa Transporte Escolar
                                    </a>
                                    <a href="https://nld.gob.mx/assets/normatividad/normatividad9.pdf" target="_blank">
                                        Reglas de Operación del Programa Apoyo Uniformes Escolares UNE
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Columna Derecha: Obligaciones y Leyes -->
                <div class="col-md-6">
                    <div class="info-card">
                        <h3 class="card-title">Obligaciones y Leyes</h3>
                        <ul class="link-list">
                            <li>
                                <a href="https://transparencia.nld.gob.mx/" target="_blank">
                                    <i class="bi bi-eye"></i>
                                    <span>Obligaciones de Transparencia</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://transparencia.nld.gob.mx/ley-general" target="_blank">
                                    <i class="bi bi-journal-text"></i>
                                    <span>Ley General de Contabilidad Gubernamental</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://transparencia.nld.gob.mx/ley-disciplina" target="_blank">
                                    <i class="bi bi-clipboard-check"></i>
                                    <span>Ley de Disciplina Financiera</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://nld.gob.mx/assets/documentos/cxlviii-63-250523.pdf#page=16"
                                    target="_blank">
                                    <i class="bi bi-hammer"></i>
                                    <span>Remate a través de Subasta Pública 2023-01</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>

        <!-- SECCIÓN 2: PROYECTO ALCANTARILLADO -->
        <div class="info-card my-4">
            <div class="project-header">
                <h3 class="project-title">
                    <i class="bi bi-water"></i>
                    Proyecto: "Ampliación y mejoramiento de los sistemas de alcantarillado y saneamiento del Municipio
                    de Nuevo Laredo"
                </h3>
            </div>
            <div class="document-links mt-3">
                <div class="row g-3">
                    <div class="col-md-6">
                        <a href="https://transparencia.nld.gob.mx/ley-disciplina" target="_blank"
                            class="doc-link">
                            <i class="bi bi-file-earmark-text"></i>
                            <span>Enlace para acceder a Ley de Disciplina Financiera</span>
                        </a>
                    </div>
                  
                </div>
            </div>
            <div class="accordion-group">

                <!-- Disciplina Financiera -->
                <div class="accordion-item-custom">
                    <button class="accordion-btn" (click)="toggleDisciplina()">
                        <i class="bi bi-graph-up"></i>
                        <span>Disciplina Financiera</span>
                        <i class="bi" [ngClass]="disciplinaFinanciera ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                    <div class="accordion-content" *ngIf="disciplinaFinanciera">
                        <div class="sub-links">
                            <a href="https://gtransparencia3.nld.gob.mx/app_ws/assets/archivos/ley_disiplina_financiera.pdf"
                                target="_blank">
                                1. Ley de Disciplina Financiera
                            </a>
                            <a href="https://www.disciplinafinanciera.hacienda.gob.mx/es/DISCIPLINA_FINANCIERA/Municipios_2022"
                                target="_blank">
                                2. Sistema de Alertas de la SHCP
                            </a>
                            <a href="https://transparencia.nld.gob.mx/financiera-laredo" target="_blank">
                                3. Disciplina Financiera en Nuevo Laredo, Tamaulipas
                            </a>
                            <a href="https://transparencia.nld.gob.mx/informacion-historica" target="_blank">
                                4. Información Histórica
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Ingresos Ramo 28 -->
                <div class="accordion-item-custom">
                    <button class="accordion-btn" (click)="toggleRamo28()">
                        <i class="bi bi-cash-coin"></i>
                        <span>Informe de la evolución de los ingresos por participaciones federales del ramo 28</span>
                        <i class="bi" [ngClass]="ramo28 ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                    <div class="accordion-content" *ngIf="ramo28">
                        <div class="sub-links">
                            <a href="https://nld.gob.mx/assets/pdfs/Ingresos Ramo 28 Ejercicio 2022.xlsx" download>
                                Ingresos por participaciones federales ramo 28 ejercicio 2022
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/Ingreso Participaciones R28 2023.xlsx" download>
                                Ingresos por participaciones federales ramo 28 ejercicio 2023
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/Ingresos Ramo 28 Julio 2024.xlsx" download>
                                Ingresos por participaciones federales ramo 28 enero-julio 2024
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Ley de Ingresos y Presupuesto -->
                <div class="accordion-item-custom">
                    <button class="accordion-btn" (click)="togglePresupuesto()">
                        <i class="bi bi-file-earmark-spreadsheet"></i>
                        <span>Ley de Ingresos y Presupuesto de Egresos</span>
                        <i class="bi" [ngClass]="presupuesto ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                    <div class="accordion-content" *ngIf="presupuesto">
                        <div class="table-responsive">
                            <table class="data-table">
                                <thead>
                                    <tr>
                                        <th>Año</th>
                                        <th>Ley de Ingresos</th>
                                        <th>Presupuesto de Egresos</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>2020</strong></td>
                                        <td><a href="https://po.tamaulipas.gob.mx/wp-content/uploads/2020/03/cxliv-155-251219F-ANEXO.pdf"
                                                target="_blank">Ver documento</a></td>
                                        <td><a href="https://po.tamaulipas.gob.mx/wp-content/uploads/2020/01/cxliv-156-261219F-ANEXO-2.pdf"
                                                target="_blank">Ver documento</a></td>
                                    </tr>
                                    <tr>
                                        <td><strong>2021</strong></td>
                                        <td><a href="https://po.tamaulipas.gob.mx/wp-content/uploads/2021/01/cxlv-153-221220F-EV.pdf"
                                                target="_blank">Ver documento</a></td>
                                        <td><a href="https://po.tamaulipas.gob.mx/wp-content/uploads/2021/01/cxlv-156-291220F-EV.pdf"
                                                target="_blank">Ver documento</a></td>
                                    </tr>
                                    <tr>
                                        <td><strong>2022</strong></td>
                                        <td><a href="https://po.tamaulipas.gob.mx/wp-content/uploads/2022/01/cxlvi-154-281221F-EV.pdf"
                                                target="_blank">Ver documento</a></td>
                                        <td><a href="https://po.tamaulipas.gob.mx/wp-content/uploads/2022/01/cxlvi-155-291221F-EV.pdf"
                                                target="_blank">Ver documento</a></td>
                                    </tr>
                                    <tr>
                                        <td><strong>2023</strong></td>
                                        <td><a href="https://po.tamaulipas.gob.mx/wp-content/uploads/2022/12/cxlvii-154-271222-EV.pdf"
                                                target="_blank">Ver documento</a></td>
                                        <td><a href="https://po.tamaulipas.gob.mx/wp-content/uploads/2022/12/cxlvii-Ext.No_.29-301222.pdf"
                                                target="_blank">Ver documento</a></td>
                                    </tr>
                                    <tr>
                                        <td><strong>2024</strong></td>
                                        <td><a href="https://po.tamaulipas.gob.mx/wp-content/uploads/2023/12/cxlviii-155-271223-EV.pdf"
                                                target="_blank">Ver documento</a></td>
                                        <td><a href="https://po.tamaulipas.gob.mx/wp-content/uploads/2023/12/cxlviii-Ext.40-30122023-EV.pdf"
                                                target="_blank">Ver documento</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Documentos Adicionales del Proyecto -->
                <div class="document-links">
                    <h4>Documentos del Proyecto</h4>
                    <div class="row g-3">
                        <div class="col-md-6">
                            <a href="https://www.tamaulipas.gob.mx/2023/08/firman-historico-acuerdo-para-sanear-el-rio-bravo/"
                                target="_blank" class="doc-link">
                                <i class="bi bi-newspaper"></i>
                                <span>Boletín informativo</span>
                            </a>
                        </div>
                        <div class="col-md-6">
                            <a href="https://nld.gob.mx/assets/pdfs/acuerdocompromiso.pdf" target="_blank"
                                class="doc-link">
                                <i class="bi bi-file-text"></i>
                                <span>Acuerdo Compromiso (04 agosto 2023)</span>
                            </a>
                        </div>
                        <div class="col-md-6">
                            <a href="https://nld.gob.mx/assets/pdfs/acuerdocabildo.pdf" target="_blank"
                                class="doc-link">
                                <i class="bi bi-file-earmark-check"></i>
                                <span>Acuerdo de Cabildo (24 noviembre 2023)</span>
                            </a>
                        </div>
                        <div class="col-md-6">
                            <a href="https://nld.gob.mx/assets/pdfs/decretocongreso.pdf" target="_blank"
                                class="doc-link">
                                <i class="bi bi-file-earmark-ruled"></i>
                                <span>Decreto Congreso del Estado (27 junio 2024)</span>
                            </a>
                        </div>
                        <div class="col-md-6">
                            <a href="https://nld.gob.mx/assets/pdfs/calificacionfr.pdf" target="_blank"
                                class="doc-link">
                                <i class="bi bi-star"></i>
                                <span>Calificación crediticia Fitch Ratings</span>
                            </a>
                        </div>
                        <div class="col-md-6">
                            <a href="https://nld.gob.mx/assets/pdfs/consultaucef.pdf" target="_blank" class="doc-link">
                                <i class="bi bi-question-circle"></i>
                                <span>Consulta a la UCEF</span>
                            </a>
                        </div>
                        <div class="col-md-6">
                            <a href="https://nld.gob.mx/assets/pdfs/convocatoria.pdf" target="_blank" class="doc-link">
                                <i class="bi bi-megaphone"></i>
                                <span>Convocatoria</span>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Invitación Instituciones Financieras -->
                <div class="accordion-item-custom">
                    <button class="accordion-btn" (click)="toggleInvitacion()">
                        <i class="bi bi-bank"></i>
                        <span>Invitación a Instituciones Financieras</span>
                        <i class="bi" [ngClass]="invitacion ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                    <div class="accordion-content" *ngIf="invitacion">
                        <div class="bank-grid">
                            <a href="https://nld.gob.mx/assets/pdfs/banamex.pdf" target="_blank"
                                class="bank-item">Banamex</a>
                            <a href="https://nld.gob.mx/assets/pdfs/banobras.pdf" target="_blank"
                                class="bank-item">Banobras</a>
                            <a href="https://nld.gob.mx/assets/pdfs/banorte.pdf" target="_blank"
                                class="bank-item">Banorte</a>
                            <a href="https://nld.gob.mx/assets/pdfs/bbva.pdf" target="_blank" class="bank-item">BBVA</a>
                            <a href="https://nld.gob.mx/assets/pdfs/cofidan.pdf" target="_blank"
                                class="bank-item">Cofidan</a>
                            <a href="https://nld.gob.mx/assets/pdfs/multiva.pdf" target="_blank"
                                class="bank-item">Multiva</a>
                            <a href="https://nld.gob.mx/assets/pdfs/santander.pdf" target="_blank"
                                class="bank-item">Santander</a>
                            <a href="https://nld.gob.mx/assets/pdfs/scotiabank.pdf" target="_blank"
                                class="bank-item">Scotiabank</a>
                            <a href="https://nld.gob.mx/assets/pdfs/bansi.pdf" target="_blank"
                                class="bank-item">Bansi</a>
                            <a href="https://nld.gob.mx/assets/pdfs/bajio.pdf" target="_blank"
                                class="bank-item">Bajio</a>
                            <a href="https://nld.gob.mx/assets/pdfs/hsbc.pdf" target="_blank" class="bank-item">HSBC</a>
                        </div>
                    </div>
                </div>

                <!-- Anexos -->
                <div class="accordion-item-custom">
                    <button class="accordion-btn" (click)="toggleAnexos()">
                        <i class="bi bi-paperclip"></i>
                        <span>Anexos</span>
                        <i class="bi" [ngClass]="anexos ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                    <div class="accordion-content" *ngIf="anexos">
                        <div class="sub-links">
                            <a href="https://nld.gob.mx/assets/pdfs/Anexo A. Decreto de autorizacion.pdf"
                                target="_blank">
                                Anexo A. Decreto de Autorización
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/Anexo B. Autorizacion del Ayuntamiento.pdf"
                                target="_blank">
                                Anexo B. Autorización del Ayuntamiento
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/Anexo C. Dictamen Comite Tecnico de Financiamient Estatal.pdf"
                                target="_blank">
                                Anexo C. Dictamen Comité Técnico de Financiamiento Estatal
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/Anexo F. Formato sugerido de sintesis o resumen de oferta.pdf"
                                target="_blank">
                                Anexo F. Formato sugerido de síntesis o resumen de oferta
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/ANEXO E. Modelo de Fideicomiso Maestro.pdf"
                                target="_blank">
                                Anexo E. Modelo de Fideicomiso Maestro
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/Anexo D. Tabla de Amortizacion propuesta.pdf"
                                target="_blank">
                                Anexo D. Tabla de Amortización propuesta
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Junta de Aclaraciones -->
                <div class="accordion-item-custom">
                    <button class="accordion-btn" (click)="toggleJuntaAclaraciones()">
                        <i class="bi bi-clipboard2-check"></i>
                        <span>Junta de Aclaraciones</span>
                        <i class="bi" [ngClass]="juntaAclaraciones ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                    <div class="accordion-content" *ngIf="juntaAclaraciones">
                        <div class="sub-links">
                            <a href="https://nld.gob.mx/assets/pdfs/aclaraciones.pdf" target="_blank">
                                Acta de la Junta de Aclaraciones
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/imagenes.pdf" target="_blank">
                                Imágenes
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/asistencia.pdf" target="_blank">
                                Lista de Asistencia
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Presentación y Apertura de Ofertas Irrevocables -->
                <div class="accordion-item-custom">
                    <button class="accordion-btn" (click)="togglePresentacionOfertas()">
                        <i class="bi bi-envelope-open"></i>
                        <span>Presentación y Apertura de Ofertas Irrevocables</span>
                        <i class="bi" [ngClass]="presentacionOfertas ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                    <div class="accordion-content" *ngIf="presentacionOfertas">
                        <div class="sub-links">
                            <a href="https://nld.gob.mx/assets/pdfs/actayofertas.pdf" target="_blank">
                                Acta de Presentación y Apertura de Ofertas
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/hoja 2-6 mod.pdf" target="_blank">
                                Modificación hoja 2/6 Acta de presentación y apertura de ofertas
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/acta present.pdf" target="_blank">
                                Acta de presentación y apertura de Ofertas integral con modificación
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/anexospre.pdf" target="_blank">
                                Anexos acta de presentación y apertura de ofertas
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/imgs1.pdf" target="_blank">
                                Imágenes
                            </a>
                            <a href="https://nld.gob.mx/assets/pdfs/listaasistencia.pdf" target="_blank">
                                Lista de Asistencia
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Fallo -->
                <div class="accordion-item-custom">
                    <button class="accordion-btn" (click)="toggleFallo()">
                        <i class="bi bi-gavel"></i>
                        <span>Fallo</span>
                        <i class="bi" [ngClass]="fallo ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                    <div class="accordion-content" *ngIf="fallo">
                        <div class="sub-links">
                            <a href="https://nld.gob.mx/assets/pdfs/actafallo.pdf" target="_blank">
                                Acta de Fallo
                            </a>
                        </div>
                    </div>
                </div>
                
            </div>

            <!-- Títulos y Sección CAP -->
            <div class="accordion-content mt-4">
                <a>Contrato de Crédito</a>
            </div>

            <div class="accordion-content mt-4">
                <a>Contratación de Instrumento de Cobertura (CAP) Derivado</a>
            </div>

            <div class="accordion-group">
                <!-- Invitación Instituciones Financieras - CAP -->
                <div class="accordion-item-custom">
                    <button class="accordion-btn" (click)="toggleInvitacionCAP()">
                        <i class="bi bi-bank2"></i>
                        <span>Invitación a Instituciones Financieras - CAP</span>
                        <i class="bi" [ngClass]="invitacionCAP ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                    <div class="accordion-content" *ngIf="invitacionCAP">
                        <div class="bank-grid">
                            <a href="https://nld.gob.mx/assets/documentos/contrato_credito/banobras.pdf" target="_blank"
                                class="bank-item">Banobras</a>
                            <a href="https://nld.gob.mx/assets/documentos/contrato_credito/bbva.pdf" target="_blank"
                                class="bank-item">BBVA</a>
                            <a href="https://nld.gob.mx/assets/documentos/contrato_credito/sant.pdf" target="_blank"
                                class="bank-item">Santander</a>
                            <a href="https://nld.gob.mx/assets/documentos/contrato_credito/skotia.pdf" target="_blank"
                                class="bank-item">Scotiabank</a>
                            <a href="https://nld.gob.mx/assets/documentos/contrato_credito/banorte.pdf" target="_blank"
                                class="bank-item">Banorte</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Enlaces finales CAP -->
            <div class="document-links mt-3">
                <div class="row g-3">
                    <div class="col-md-6">
                        <a href="https://nld.gob.mx/assets/documentos/contrato_credito/acta_pr_ap.pdf"
                            target="_blank" class="doc-link">
                            <i class="bi bi-file-earmark-text"></i>
                            <span>Acta de Presentación y Apertura de Ofertas - CAP</span>
                        </a>
                    </div>
                    <div class="col-md-6">
                        <a href="https://nld.gob.mx/assets/documentos/contrato_credito/acta_fallo.pdf"
                            target="_blank" class="doc-link">
                            <i class="bi bi-file-earmark-check"></i>
                            <span>Acta de Fallo - CAP</span>
                        </a>
                    </div>
                </div>
            </div>

        </div>

        <!-- SECCIÓN 3: RAMO 33 Y MEDIO AMBIENTE -->
        <div class="row g-4 my-4">

            <!-- RAMO 33 -->
            <div class="col-md-6">
                <div class="info-card">
                    <h3 class="card-title">
                        <i class="bi bi-folder"></i>
                        FISM (Fondo Infraestructura Social Municipal)
                    </h3>

                    <div class="year-accordion">
                        <div class="year-item" *ngFor="let year of years" (click)="toggleYear(year.id)">
                            <div class="year-header">
                                <span>RAMO 33 Ejercicio Fiscal {{year.year}}</span>
                                <i class="bi" [ngClass]="year.expanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                            </div>
                            <div class="year-content" *ngIf="year.expanded">
                                <a *ngFor="let trimestre of year.trimestres" [href]="trimestre.url" target="_blank"
                                    class="trimestre-link">
                                    {{trimestre.label}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Medio Ambiente -->
            <div class="col-md-6">
                <div class="info-card">
                    <h3 class="card-title">
                        <i class="bi bi-leaf"></i>
                        Dirección de Medio Ambiente y Cambio Climático
                    </h3>
                    <div class="environment-link">
                        <a href="https://nld.gob.mx/assets/documentos/cambioClimatico.pdf" target="_blank"
                            class="featured-link">
                            <i class="bi bi-file-earmark-pdf"></i>
                            <div>
                                <strong>Programas de Protección al Medio Ambiente</strong>
                                <span>y el Programa Municipal de Adaptación y Mitigación al Cambio Climático</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

        </div>

        <!-- SECCIÓN 4: DECLARACIÓN PATRIMONIAL -->
        <div class="info-card my-4">
            <h3 class="card-title">
                <i class="bi bi-file-person"></i>
                Formato de la Declaración de Situación Patrimonial
            </h3>

            <div class="row g-3 mb-4">
                <div class="col-md-6 col-lg-4">
                    <a href="https://nld.gob.mx/assets/pdfs/FORMATO_DE_LA_DECLARACION_DE_INICIO2021.pdf" target="_blank"
                        class="format-card">
                        <i class="bi bi-file-earmark-text"></i>
                        <span>Formato Inicial</span>
                    </a>
                </div>
                <div class="col-md-6 col-lg-4">
                    <a href="https://nld.gob.mx/assets/pdfs/FORMATO_DE_LA_DECLARACION_DE_INICIO Version Simplificada.pdf"
                        target="_blank" class="format-card">
                        <i class="bi bi-file-earmark"></i>
                        <span>Formato Inicial Versión Simplificada</span>
                    </a>
                </div>
                <div class="col-md-6 col-lg-4">
                    <a href="https://nld.gob.mx/assets/pdfs/FORMATO_DE_LA_DECLARACION_DE_MODIFICACION.pdf"
                        target="_blank" class="format-card">
                        <i class="bi bi-file-earmark-diff"></i>
                        <span>Formato Modificación</span>
                    </a>
                </div>
                <div class="col-md-6 col-lg-4">
                    <a href="https://nld.gob.mx/assets/pdfs/FORMATO_DE_LA_DECLARACION_DE_MODIFICACION Version Simplificada.pdf"
                        target="_blank" class="format-card">
                        <i class="bi bi-file-earmark-minus"></i>
                        <span>Formato Modificación Versión Simplificada</span>
                    </a>
                </div>
                <div class="col-md-6 col-lg-4">
                    <a href="https://nld.gob.mx/assets/pdfs/conclusion.pdf" target="_blank" class="format-card">
                        <i class="bi bi-file-earmark-check"></i>
                        <span>Formato Conclusión</span>
                    </a>
                </div>
            </div>

            <div class="digital-declaration">
                <h4>Declaración Patrimonial Digital</h4>
                <p>Realiza tu declaración patrimonial de manera digital a través de las siguientes plataformas:</p>

                <div class="declaration-logos">
                    <a href="https://declaracionpatrimonial.nld.gob.mx/" target="_blank" class="logo-link">
                        <img src="assets/img/GOBNLD.png" alt="Gobierno NLD" />
                        <span>Gobierno NLD</span>
                    </a>
                    <a href="http://declaracionpatrimonialcomapa.nld.gob.mx/" target="_blank" class="logo-link">
                        <img src="assets/img/COMAPA.png" alt="COMAPA" />
                        <span>COMAPA</span>
                    </a>
                    <a href="http://declaracionimjuve.nld.gob.mx/" target="_blank" class="logo-link">
                        <img src="assets/img/IMJUVE.png" alt="IMJUVE" />
                        <span>IMJUVE</span>
                    </a>
                    <a href="http://declaracionimpacta.nld.gob.mx/" target="_blank" class="logo-link">
                        <img src="assets/img/IMPACTA.png" alt="IMPACTA" />
                        <span>IMPACTA</span>
                    </a>
                    <a href="http://declaracionimpladu.nld.gob.mx/" target="_blank" class="logo-link">
                        <img src="assets/img/IMPLADU.png" alt="IMPLADU" />
                        <span>IMPLADU</span>
                    </a>
                    <a href="http://declaracioninmujer.nld.gob.mx/" target="_blank" class="logo-link">
                        <img src="assets/img/INMUJER.png" alt="INMUJER" />
                        <span>INMUJER</span>
                    </a>
                    <a href="http://declaracionpatrimonialicce.nld.gob.mx/" target="_blank" class="logo-link">
                        <img src="assets/img/logo_icce.png" alt="ICCE" />
                        <span>ICCE</span>
                    </a>
                    <a href="http://declaracionpatrimonialimvisu.nld.gob.mx/" target="_blank" class="logo-link">
                        <img src="assets/img/logoImvisu.png" alt="IMVISU" />
                        <span>IMVISU</span>
                    </a>
                    <a href="http://declaraciondif.nld.gob.mx/" target="_blank" class="logo-link">
                        <img src="https://beneficiariosdif1821.nld.gob.mx/assets/images/mini_ciac.png" alt="DIF" />
                        <span>DIF</span>
                    </a>
                </div>
            </div>
        </div>

    </div>
</div>